import Component from './Component';

/**
 * @class BlockComponent
 * @classdesc Class representing a block component.
 * @extends Component
 */
export default class BlockComponent extends Component {
  /**
   * Called when the component is selected in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onSelect() {
    return undefined;
  }

  /**
   * Called when the component is deselected in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onDeselect() {
    return undefined;
  }

  /**
   * Called when the component is reordered in the Shopify Theme Editor.
   *
   * @memberof SectionComponent.prototype
   */
  onReorder() {
    return undefined;
  }
}
